<script lang="ts">
	interface Props {
		strokeColor?: string
	}

	let { strokeColor = "black" }: Props = $props()
</script>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M37.5 25L62.5 50L37.5 75"
		class="svg-stroke"
		stroke={strokeColor}
		stroke-width="8.33333"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>

<style>
</style>
